<template>
  <div class="container-modal mx-auto px-0 pb-3 flex justify-center cointainer-admins-evento">
    <button
      @click="open()"
      class="boton-front bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-1 rounded w-full mb-4"
    >
      {{ uiT('eventAdmins.title') }}
    </button>

    <!-- ✅ Teleport: saca el modal fuera del DOM del componente -->
    <teleport to="body">
      <div
        v-if="showModal"
        class="admins-modal-overlay"
        @click.self="close()"
      >
        <div class="admins-modal-card bg-white p-6 rounded-lg shadow-lg w-full">
          <div class="flex items-center justify-between mb-4">
            <p class="text-2xl font-bold">{{ uiT('eventAdmins.title') }}</p>
            <button
              @click="close()"
              class="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-3 rounded"
            >
              {{ uiT('common.close') }}
            </button>
          </div>

          <div v-if="loading">{{ uiT('common.loading') }}</div>

          <div v-else>
            <div v-if="admins.length === 0" class="text-gray-600 mb-4">
              {{ uiT('eventAdmins.none') }}
            </div>

            <div v-else class="mb-6">
              <table class="w-full text-sm">
                <thead>
                  <tr class="text-left border-b">
                    <th class="py-2">{{ uiT('moderators.name') }}</th>
                    <th class="py-2">{{ uiT('moderators.email') }}</th>
                    <th class="py-2">{{ uiT('eventAdmins.role') }}</th>
                    <th class="py-2 text-right">{{ uiT('moderators.actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="a in admins" :key="a.user_id" class="border-b">
                    <td class="py-2">{{ a.nombre }}</td>
                    <td class="py-2">{{ a.email }}</td>
                    <td class="py-2">{{ a.rol || "—" }}</td>
                    <td class="py-2 text-right">
                      <button
                        v-if="!fechaCorte"
                        @click="remove(a)"
                        class="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-3 rounded"
                      >
                        {{ uiT('eventAdmins.remove') }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Agregar / asignar -->
            <div class="border-t pt-4">
              <p class="text-lg font-bold mb-3">{{ uiT('eventAdmins.addTitle') }}</p>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label class="font-medium text-gray-700">Email</label>
                  <input
                    v-model="form.email"
                    type="email"
                    class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
                  />
                </div>

                <div>
                  <label class="font-medium text-gray-700">{{ uiT('eventAdmins.nameIfCreated') }}</label>
                  <input
                    v-model="form.nombre"
                    type="text"
                    class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
                  />
                </div>
              </div>

              <div class="mt-3">
                <label class="inline-flex items-center">
                  <input type="checkbox" v-model="form.crearNuevo" class="mr-2" />
                  {{ uiT('eventAdmins.newUser') }}
                </label>
              </div>

              <div v-if="form.crearNuevo" class="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
                <div>
                  <label class="font-medium text-gray-700">{{ uiT('superAdmin.password') }}</label>
                  <input
                    v-model="form.password"
                    type="password"
                    class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
                  />
                </div>
                <div>
                  <label class="font-medium text-gray-700">{{ uiT('superAdmin.confirmPassword') }}</label>
                  <input
                    v-model="form.confirmPassword"
                    type="password"
                    class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
                  />
                </div>
              </div>

              <div class="mt-4 flex gap-2">
                <button
                  v-if="!fechaCorte"
                  @click="submit()"
                  class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                >
                  {{ uiT('common.save') }}
                </button>
                <button
                  @click="resetForm()"
                  class="bg-gray-200 hover:bg-gray-300 text-gray-900 font-bold py-2 px-4 rounded"
                >
                  {{ uiT('common.clear') }}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import { userManagementI18nMixin } from "@/views/usuarios/i18n/userManagementI18n.js";

export default {
  mixins: [userManagementI18nMixin],
  props: {
    eventoToken: { type: String, required: true },
    fechaCorte: { type: Boolean, default: false },
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      showModal: false,
      loading: false,
      admins: [],
      prevBodyOverflow: "",
      form: {
        email: "",
        nombre: "",
        crearNuevo: false,
        password: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    async open() {
      this.showModal = true;

      // ✅ lock scroll del body (evita “scroll doble”)
      this.prevBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";

      // ✅ cerrar con ESC
      window.addEventListener("keydown", this._onKeydown, { passive: true });

      await this.fetchAdmins();
    },
    close() {
      this.showModal = false;

      // ✅ restore scroll
      document.body.style.overflow = this.prevBodyOverflow || "";

      // ✅ quitar listener
      window.removeEventListener("keydown", this._onKeydown);
    },
    _onKeydown(e) {
      if (e.key === "Escape") this.close();
    },
    async fetchAdmins() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/api/administrador-evento/list/${this.eventoToken}`);
        this.admins = data.admins || [];
      } catch (e) {
        console.error(e);
        this.toast.error(this.uiT('eventAdmins.loadError'));
      } finally {
        this.loading = false;
      }
    },
    validateEmail(email) {
      const re =
        /^([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    async submit() {
      const email = (this.form.email || "").trim();
      if (!this.validateEmail(email)) {
        this.toast.warning(this.uiT('superAdmin.invalidEmail'));
        return;
      }

      if (this.form.crearNuevo) {
        if ((this.form.password || "").length < 8) {
          this.toast.warning(this.uiT('eventAdmins.passwordMin'));
          return;
        }
        if (this.form.password !== this.form.confirmPassword) {
          this.toast.warning(this.uiT('superAdmin.passwordMismatch'));
          return;
        }
      }

      try {
        const payload = {
          eventoToken: this.eventoToken,
          email,
          nombre: (this.form.nombre || "").trim(),
          password: this.form.crearNuevo ? this.form.password : "",
        };

        await axios.post("/api/administrador-evento/upsert", payload);
        this.toast.success(this.uiT('eventAdmins.ready'));
        this.resetForm();
        await this.fetchAdmins();
        this.$emit("userCreated");
      } catch (e) {
        console.error(e);
        this.toast.error(this.uiT('eventAdmins.saveError'));
      }
    },
    async remove(admin) {
      if (!admin || !admin.user_id) return;
      if (!confirm(this.uiT('eventAdmins.removeConfirm', { email: admin.email }))) return;

      try {
        await axios.post("/api/administrador-evento/remove", {
          eventoToken: this.eventoToken,
          user_id: admin.user_id,
        });
        this.toast.success(this.uiT('eventAdmins.removed'));
        await this.fetchAdmins();
        this.$emit("userCreated");
      } catch (e) {
        console.error(e);
        this.toast.error(this.uiT('eventAdmins.removeError'));
      }
    },
    resetForm() {
      this.form = {
        email: "",
        nombre: "",
        crearNuevo: false,
        password: "",
        confirmPassword: "",
      };
    },
  },
  beforeUnmount() {
    // ✅ por si se desmonta con modal abierto
    window.removeEventListener("keydown", this._onKeydown);
    document.body.style.overflow = this.prevBodyOverflow || "";
  },
};
</script>

<style scoped>
.container-modal { flex-direction: column; }
.boton-front { width: 100%; max-width: 800px; }

/* ✅ Overlay real: arriba de TODO */
.admins-modal-overlay{
  position: fixed;
  inset: 0;
  z-index: 999999;         /* 🔥 arriba de lo que sea */
  background: rgba(0,0,0,.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;           /* margen en pantallas pequeñas */
}

/* ✅ Card: evita que se salga del viewport */
.admins-modal-card{
  max-width: 900px;
  max-height: calc(100vh - 32px);
  overflow: auto;          /* scroll interno si crece */
  border-radius: 12px;
}
</style>
